module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-59.42afe1c.woff2";